// Detectar que hay una versión nueva publicada.
//
// Al desplegar, el archivo principal cambia de nombre (main.0247c93f.js pasa a
// ser otro) y el index.html apunta al nuevo. Quien refresque lo recibe solo;
// quien deje la aplicación abierta en el celular durante días se queda con la
// vieja sin saberlo, y si se arregló un fallo importante no le llega.
//
// Se compara el nombre del archivo que está cargado ahora mismo contra el que
// anuncia el index.html del servidor. No se usa el evento de actualización del
// Service Worker porque ese archivo solo cambia cuando se toca a mano: un
// despliegue que solo cambie la aplicación pasaría desapercibido.

const PATRON = /main\.[a-z0-9]+\.js/;

// El archivo que el navegador tiene cargado en este momento.
export function versionCargada() {
  const script = [...document.querySelectorAll('script[src]')]
    .map((s) => s.getAttribute('src'))
    .find((src) => PATRON.test(src));
  return script ? script.match(PATRON)[0] : null;
}

// El que anuncia el servidor. Devuelve null si no se puede saber —sin conexión,
// por ejemplo— para no avisar de una actualización que no existe.
export async function versionPublicada() {
  try {
    const r = await fetch('/index.html', { cache: 'no-store' });
    if (!r.ok) return null;
    const html = await r.text();
    const encontrado = html.match(PATRON);
    return encontrado ? encontrado[0] : null;
  } catch (e) {
    return null;
  }
}

export async function hayVersionNueva() {
  const cargada = versionCargada();
  if (!cargada) return false;

  const publicada = await versionPublicada();
  return Boolean(publicada) && publicada !== cargada;
}
